import { TimeSlot } from "@/types/datetime";
import { formatDate } from "@/utils/datetime";

// Keep in sync with backend settings
export const DEFAULT_CALENDAR_DAYS = 180;

export function getTimeslotsByDate(
  timeslots: TimeSlot[] = [],
  dateString: string,
  timezone: string,
): TimeSlot[] {
  return timeslots.filter((timeslot) => {
    const timeslotByClientTimezone = formatDate(
      timeslot.timeSlot,
      "MM-dd-yyyy",
      timezone,
    );
    return dateString === timeslotByClientTimezone;
  });
}

export function mapCalendarDate(
  timeslots: TimeSlot[] = [],
  timezone = "UTC",
): Record<string, boolean> {
  return timeslots.reduce<Record<string, boolean>>((res, timeslot) => {
    const timeslotByClientTimezone = formatDate(
      timeslot.timeSlot,
      "MM-dd-yyyy",
      timezone,
    );
    res[timeslotByClientTimezone || ""] = true;
    return res;
  }, {});
}

// Add this helper function to convert dateString to Date
export function dateStringToDate(dateStr: string | null): Date | undefined {
  if (!dateStr) return undefined;
  const [month, day, year] = dateStr.split("-").map(Number);
  return new Date(year, month - 1, day);
}
